import { render, staticRenderFns } from "./articleEditor.vue?vue&type=template&id=7d06f106&"
import script from "./articleEditor.vue?vue&type=script&lang=js&"
export * from "./articleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d06f106')) {
      api.createRecord('7d06f106', component.options)
    } else {
      api.reload('7d06f106', component.options)
    }
    module.hot.accept("./articleEditor.vue?vue&type=template&id=7d06f106&", function () {
      api.rerender('7d06f106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/base/article-editor/articleEditor.vue"
export default component.exports